// ANCHOR Base
import { Button, KIND, SIZE } from 'baseui/button';

// ANCHOR Models
import { ConfirmationModalLogic } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalLogic';
import { ConfirmationModalVisibility } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalVisibility';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constant
import { CANCEL, NO } from './constants';

// ANCHOR Styles
import { BUTTON } from './styles';

export const LyonConfirmationModalCancelButton = constant(() => {
  const hide = ConfirmationModalVisibility.useSelector((state) => state.hide);
  const [
    isStrict,
    cancelLabel,
  ] = ConfirmationModalLogic.useSelectors(({ state }) => [
    state.isStrict,
    state.cancelLabel,
  ]);

  const defaultLabel = isStrict ? CANCEL : NO;

  return (
    <Button
      overrides={BUTTON}
      onClick={hide}
      kind={KIND.secondary}
      size={SIZE.default}
    >
      {cancelLabel || defaultLabel}
    </Button>
  );
});
